import styled, { css } from 'styled-components';

import ActionButton from 'components/action-button';

export const FabContainer = styled.div<{
  $badgeContent?: string | number | undefined;
  $badgeColor?: string | undefined;
  $badgeBgColor?: string | undefined;
  $badgeBgBorderRadius?: string | undefined;
}>`
  position: absolute;
  right: -0.625rem;
  bottom: 0;
  padding-right: 1.125rem;
  padding-bottom: 1.75rem;
  ${({ $badgeContent, $badgeColor, $badgeBgColor, $badgeBgBorderRadius }) =>
    $badgeContent &&
    css`
      ::after {
        background: ${$badgeBgColor || Styles.color.contrastBackground};
        color: ${$badgeColor || Styles.color.white};
        border-radius: ${$badgeBgBorderRadius || Styles.borderRadius};
        content: '${$badgeContent}';
        font-family: ${Styles.fontFamily.base};
        font-size: 0.725rem;
        height: 1.125rem;
        position: absolute;
        right: 1rem;
        text-align: center;
        top: -0.5rem;
        width: 1.125rem;
      }
    `}
`;

export const StyledActionButton = styled(ActionButton)`
  background-color: ${Styles.color.primary};
  font-size: 16px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  box-shadow: 0px 4px 10px 0px #00000040;
  &:hover {
    background-color: ${Styles.color.primaryHover};
  }
`;
